var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetesGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg27",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .cls-diab-general2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diabetes_General",
    transform: "translate(0,-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-diab-general13",
    clipPath: "url(#clippath)",
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-diab-general2",
    d: "m 12.75,6.07 c 0,0 -6,7.83 -7.19,12.32 -1.39,5.25 4.09,9.88 9.94,7.72",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-diab-general7",
    clipPath: "url(#clippath-1)",
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-diab-general2",
    d: "m 7.91,20.83 c 0.54,1.86 2.33,2.97 4.13,3.38",
    id: "path9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-diab-general12",
    clipPath: "url(#clippath-2)",
    id: "g11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-diab-general2",
    d: "M 19.53,22.81 C 17.85,26.25 13.45,27.43 10,26.16",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-diab-general2",
    d: "m 12.75,6.07 c 1.24,1.64 2.43,3.33 3.54,5.07",
    id: "path11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-diab-general2",
    x: 13.88,
    y: 15.47,
    width: 5.0599999,
    height: 5,
    id: "rect12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-diab-general2",
    x1: 15.83,
    y1: 13.47,
    x2: 13.88,
    y2: 15.4,
    id: "line12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-diab-general2",
    x1: 20.879999,
    y1: 13.47,
    x2: 18.940001,
    y2: 15.4,
    id: "line13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-diab-general2",
    x1: 20.879999,
    y1: 18.549999,
    x2: 18.940001,
    y2: 20.469999,
    id: "line14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-diab-general2",
    d: "m 20.88,13.47 v 5.08 z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-diab-general2",
    x1: 15.83,
    y1: 13.47,
    x2: 20.879999,
    y2: 13.47,
    id: "line15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetesGeneral);
export default __webpack_public_path__ + "static/media/DiabetesGeneral.19450bfe72f68e925ddc4236af1f243d.svg";
export { ForwardRef as ReactComponent };